export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '报案时间',
		align: 'center',
		dataIndex: 'callTime',
		scopedSlots: { customRender: 'callTime' },
	},
	{
		title: '处理环节',
		align: 'center',
		dataIndex: 'node',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'registNo',
	},
	{
		title: '保单号',
		align: 'center',
		dataIndex: 'policyNo',
	},
	{
		title: '被保人姓名',
		align: 'center',
		dataIndex: 'insurantName',
	},
	{
		title: '伤者姓名',
		align: 'center',
		dataIndex: 'name',
	},
	{
		title: '损失类型',
		align: 'center',
		dataIndex: 'lossType',
	},
	// {
	// 	title: '处理人',
	// 	align: 'center',
	// 	dataIndex: 'companyName1',
	// },
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
